module.exports = __webpack_public_path__ + "img/powerImg5.549edd2f.jpg";